import React, { useEffect, useState } from "react";
import { PublicFileUrl, fileUrl } from "../../../../services/config";
import { getApi } from "../../../../services/api/globalApi";
import { PiCopySimpleBold, PiImageSquareFill, PiXFill } from "react-icons/pi";
import { successMessage } from "../../../../utils/toastify-message/ToastifyMessage";

const { forwardRef, useRef, useImperativeHandle } = React;

const ImagesModal = forwardRef(({ selectedImages, selectImg = true }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      // window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const [fileData, setFileData] = useState([]);
  const [filteredFileData, setFilteredFlesData] = useState([]);

  const getFiles = async () => {
    const path = "admin/filemanagers/files";
    try {
      const data = await getApi({ path });
      console.log(data.data.files);
      setFileData(data?.data.files);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFiles();
  }, []);

  useEffect(() => {
    if (fileData?.length > 0) {
      let filtred = fileData.filter((item) => {
        return !(
          item.name.startsWith("medium") || item.name.startsWith("thumb")
        );
      });
      console.log(fileData);
      setFilteredFlesData(filtred);
      setFilterByName(filtred);
    }
  }, [fileData]);

  const selectImage = (item) => {
    console.log(item);
    selectedImages({
      name: item.name,
      isMain: false,
    });
    setShowModal(false);
  };

  const [filterByName, setFilterByName] = useState([]);

  const [searchFile, setSearchFile] = useState("");

  useEffect(() => {
    const filteredData = filteredFileData.filter((item) =>
      item.name.toLowerCase().includes(searchFile.toLowerCase())
    );
    setFilterByName(filteredData);
  }, [searchFile]);

  const copyImgUrl = (item) => {
    navigator.clipboard.writeText(
      `${PublicFileUrl}public/files/medium_${item.name}`
    );
    successMessage("لینک عکس کپی شد.");
    setShowModal(false);
  };


  
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);


  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-[2000]  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[90%] py-4 overflow-hidden bg-white dark:bg-gray-800 shadow-md z-[2010] rounded-3xl p-4 transition-all fixed top-0 bottom-[5%] right-[50%] mr-[-45%] opacity-0 invisible ${
          showModal && "!mt-[5%] !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2 text-gray-800 dark:text-white">
          <h4>آخرین عکس ها</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>

        <div class="max-w-md mx-auto my-2">
          <div class="relative">
            <div class="absolute inset-y-0 end-0 flex items-center pe-3 pointer-events-none">
              <svg
                class="w-4 h-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 20"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                />
              </svg>
            </div>
            <input
              onChange={(e) => setSearchFile(e.target.value)}
              type="search"
              className="bg-white text-center sm:text-right border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder="جست و جو محصول ..."
              required
            />
          </div>
        </div>

        {filterByName?.length > 0 && showModal ? (
          <div className="flex items-center flex-wrap w-full justify-around gap-4 mt-6 overflow-y-scroll h-[calc(100%-8rem)]">
            {filterByName.map((item, index) => {
              return (
                <div
                  key={index}
                  className="w-32 h-32 md:w-56 md:h-56 overflow-hidden cursor-pointer rounded-lg flex items-center justify-center relative"
                >
                  <PiCopySimpleBold
                    onClick={() => copyImgUrl(item)}
                    className="absolute top-1 right-1 text-white bg-blue-300 transition-all hover:bg-blue-500 rounded-lg p-1 z-10"
                    size={36}
                  />
                  {selectImg ? (
                    <div
                      onClick={() => selectImage(item)}
                      className="absolute top-[0] opacity-0 right-0 w-full h-full transition-all hover:opacity-100 bg-black/10 text-white flex items-center justify-center"
                    >
                      انتخاب
                    </div>
                  ) : null}
                  <img
                    className="object-cover rounded-lg transition-all hover:scale-105"
                    src={`${fileUrl}files/medium_${item.name}`}
                    alt=""
                  />
                </div>
              );
            })}
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 py-4 w-full mt-6 text-gray-700">
            عکسی یافت نشد
            <PiImageSquareFill size={50} />
          </div>
        )}
      </div>
    </>
  );
});
export default ImagesModal;
